module.exports = __webpack_public_path__ + "img/DOE-Logo@4x1_4.0ad1e684.svg";